var _style, _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNikeTeamMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92.3 92.7",
    style: {
      enableBackground: "new 0 0 92.3 92.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#22242B;}\n\t.st1{fill:#8E9090;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 92.3,
    height: 92.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.8,85.5h78.4V7.2H6.8L6.8,85.5L6.8,85.5z M84.2,84.5H7.8V8.1h76.4V84.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.9,25.9c-1.5,3-2.7,7.3,0.7,9.7c1.3,1,3,1.1,4.6,0.7l43.4-10.9l-43,17.8c-3.8,1.6-9,2.6-12-0.9 c-1.3-1.5-1.3-3.5-0.8-5.4C19,32.5,22,29.2,24.9,25.9"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "19.5,58.8 16.7,58.8 16.7,57.8 23.5,57.8 23.5,58.8 20.7,58.8 20.7,66.6 19.5,66.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "33.2,57.8 39.1,57.8 39.1,58.9 34.4,58.9 34.4,61.5 38.5,61.5 38.5,62.6 34.4,62.6 34.4,65.5  39.2,65.5 39.2,66.6 33.2,66.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52,57.8h1.1l3.3,8.8h-1.3l-0.8-2.3h-3.6l-0.9,2.3h-1.2L52,57.8z M54,63.2l-1.4-4l0,0l-1.4,4H54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "66.2,57.8 67.7,57.8 70.3,63.2 70.4,63.2 73,57.8 74.5,57.8 74.5,66.6 73.3,66.6 73.3,59.9  73.3,59.9 70.8,64.9 69.8,64.9 67.4,60 67.4,60 67.4,66.6 66.2,66.6  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNikeTeamMobile);
export default __webpack_public_path__ + "static/media/NIKE_TEAM_Mobile.2cd0e42324cccd61f167934543319b06.svg";
export { ForwardRef as ReactComponent };